export enum ClientAdvanceStatus {
  /** Created; not yet received. No Payment exists yet — call receive() to attach one. */
  DRAFT = "DRAFT",
  /** Money received. May be partially settled — check settledAmount/settleableAmount, there's no separate "partially settled" status. */
  PROCESSED = "PROCESSED",
  SETTLED = "SETTLED",
  CANCELLED = "CANCELLED",
  /** Full remaining (un-settled) balance refunded — no partial refunds. */
  REFUNDED = "REFUNDED",
}

export enum ClientAdvanceSourceType {
  AMC = "AMC",
  WORK_ORDER = "WORK_ORDER",
  PETTY_WORK = "PETTY_WORK",
}

export const ClientAdvanceSourceTypeLabel: Record<
  ClientAdvanceSourceType,
  string
> = {
  [ClientAdvanceSourceType.AMC]: "AMC",
  [ClientAdvanceSourceType.WORK_ORDER]: "Work Order",
  [ClientAdvanceSourceType.PETTY_WORK]: "Petty Work",
};

/** How the advance amount was entered; `amount` is always the resolved rupee value. */
export enum ClientAdvanceValueType {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
}

export const ClientAdvanceValueTypeLabel: Record<
  ClientAdvanceValueType,
  string
> = {
  [ClientAdvanceValueType.FIXED]: "Fixed (₹)",
  [ClientAdvanceValueType.PERCENTAGE]: "Percentage (%)",
};

export const clientAdvanceStatusMap: Record<
  ClientAdvanceStatus,
  { label: string; color: string; hint?: string }
> = {
  [ClientAdvanceStatus.DRAFT]: {
    label: "Awaiting Receipt",
    color: "info",
    hint: "Recorded but not yet received — no payment exists yet.",
  },
  [ClientAdvanceStatus.PROCESSED]: {
    label: "Processed",
    color: "success",
    hint: "Received — may be fully or partially settled; see settled/settleable amounts.",
  },
  [ClientAdvanceStatus.SETTLED]: {
    label: "Settled",
    color: "primary",
  },
  [ClientAdvanceStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
  },
  [ClientAdvanceStatus.REFUNDED]: {
    label: "Refunded",
    color: "dark",
    hint: "Full remaining balance was refunded to the client.",
  },
};
